import React from 'react';
import { ArrowRight, Shield, TrendingUp, Handshake } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216"
          alt="Professional Business"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-900/85 to-blue-900/75"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-32 relative z-10">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
            <TrendingUp className="text-white" size={20} />
            <span className="text-white text-sm font-medium">Per PMI Svizzere</span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Partner affidabile
            <br />
            <span className="text-gray-200">per la successione aziendale</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl leading-relaxed">
            Alfa Equity nasce con l’obiettivo di garantire continuità alle piccole e medie imprese svizzere 
            in fase di passaggio generazionale o di cambiamento societario. 
            Selezioniamo e rileviamo attività solide, con basi finanziarie sane e potenziale di sviluppo.
        
          </p>

          {/* Key Points */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="flex items-start space-x-3">
              <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                <TrendingUp className="text-white" size={24} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Analisi indipendente</h3>
                <p className="text-gray-300 text-sm">Valutazione interna propedeutica all’acquisto</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                <Handshake className="text-white" size={24} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Proposta di acquisizione</h3>
                <p className="text-gray-300 text-sm">Avanziamo proposte eque e trasparenti</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                <Shield className="text-white" size={24} />
              </div>
              <div>
                <h3 className="text-white font-semibold mb-1">Garanzia di continuità</h3>
                <p className="text-gray-300 text-sm">Preserviamo le persone e le competenze</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection('contatti')}
              className="group bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 hover:shadow-2xl flex items-center justify-center space-x-2"
            >
              <span>Voglio cedere la mia attività</span>
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-all duration-300"
            >
              Scopri di più
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-white rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;